import defineObjectives from '../../../../assets/images/performance/defineObjectives.png';
import confirmObjectives from '../../../../assets/images/performance/confirmObjectives.png';
import selfAssessment from '../../../../assets/images/performance/selfAssesment.png';
import managerReview from '../../../../assets/images/performance/managerReview.png';
import calibrationResult from '../../../../assets/images/performance/calibrationResult.png';
import confirmResult from '../../../../assets/images/performance/confirmResult.png';

const steps = [
  {
    icon: defineObjectives,
    title: 'Define Objectives',
    key: 'Define_Objectives',
    tooltip:
      'Set clear and measurable performance goals aligned with business priorities.',
  },
  {
    icon: confirmObjectives,
    title: 'Confirm Objectives',
    key: 'Confirm_Objectives',
    tooltip:
      'Ensure the employee and manager agree on the set objectives before the review period begins.',
  },
  {
    icon: selfAssessment,
    title: 'Self Assessment',
    key: 'Self_Assessment',
    tooltip:
      'Employee evaluates their own performance against the defined objectives.',
  },
  {
    icon: managerReview,
    title: 'Manager Review',
    key: 'Manager_Review',
    tooltip:
      "Manager reviews the employee's performance and provides feedback and ratings.",
  },
  {
    icon: calibrationResult,
    title: 'Calibration Result',
    key: 'Calibration_Result',
    tooltip:
      'Performance ratings are reviewed and standardized across teams to ensure fairness.',
  },
  {
    icon: confirmResult,
    title: 'Confirm Result',
    key: 'Confirmation_Result',
    tooltip:
      'Final performance ratings are shared and acknowledged by both employee and manager.',
  },
];

export { steps };
